import { flare } from "@flareapp/flare-client";

if (process.env.NODE_ENV === 'production' && window.location.hostname !== 'tba-qikcms.test') {
    flare.light();
    flare.addContext('version', window.__version);
}

require('./bootstrap');

require('@wotz/livewire-sortablejs');

require('./signature-pad');

// Apply class to all external links
const links = document.querySelectorAll("a[target^='_blank']");
links.forEach(child_element => {
    if (child_element) {
        child_element?.classList?.add('external-link');
        // child_element.setAttribute('rel', 'external');
    }
});

// Apply aria to all links
const aria_links = document.querySelectorAll("a");
aria_links.forEach(child_element => {
    if (!child_element) return;
    if (child_element.getAttribute('aria-label')?.trim()) return;
    if (child_element.hasAttribute('aria-labelledby')) return;
    const label = child_element?.innerText?.replace('"', '')?.replace("'", '')?.replace('  ', ' ')?.replace('<br>', '')?.replace('<br/>', '')?.replace('\n', '')?.trim();
    if (!label) return;
    child_element.setAttribute('aria-label', label);
});

// Apply aria to all buttons
const aria_buttons = document.querySelectorAll("button");
aria_buttons.forEach(child_element => {
    if (!child_element) return;
    if (!child_element.hasAttribute('role')) {
        child_element.setAttribute('role', 'button');
    }
    if (child_element.getAttribute('aria-label')?.trim()) return;
    if (child_element.hasAttribute('aria-labelledby')) return;
    const label = child_element?.innerText?.replace('"', '')?.replace("'", '')?.replace('  ', ' ')?.replace('<br>', '')?.replace('<br/>', '')?.replace('\n', '')?.trim();
    if (!label) return;
    child_element.setAttribute('aria-label', label);
});

// Handle click away on header menu dropdowns
// const subMenuDropContainers = document.querySelectorAll(".subMenuDropContainer");
// subMenuDropContainers.forEach(subMenuDropContainer => {
//     document.addEventListener('click', event => {
//         const isClickInside = subMenuDropContainer?.contains(event.target)
//         if (!isClickInside) {
//             const subMenuDropContainerChildren = subMenuDropContainer?.querySelectorAll(".subMenuDrop");
//             if (subMenuDropContainerChildren[0]) {
//                 subMenuDropContainerChildren[0].setAttribute('style', 'display: none;');
//             }
//         }
//     })
// });

function strIncludes(haystack, needle) {
    if (needle !== undefined && needle !== null && needle !== '') {
        needle = needle.toLowerCase();
        return typeof haystack === 'string' && haystack.toLowerCase().includes(needle);
    }
    return false;
}
window.onerror = function (message, source, lineno, colno, error) {
    if (window.location.hostname === 'tba-qikcms.test'){
        return false;
    }
    if (strIncludes(message, 'contentWindow')) {
        document.getElementById('preview_frame')?.contentWindow?.location.reload();
        return true;
    }
    if (strIncludes(message, 'Snapshot missing')) {
        if (Livewire !== undefined) {
            Livewire.dispatch('refreshPageComps');
            Livewire.dispatch('reloadCompListData');
        }
        return true;
    }
    if (strIncludes(message, 'Could not find Livewire component in DOM tree')) {
        if (Livewire !== undefined) {
            Livewire.dispatch('refreshPageComps');
            Livewire.dispatch('reloadCompListData');
        }
        return true;
    }
    if (strIncludes(message, 'Component not found')) {
        if (Livewire !== undefined) {
            Livewire.dispatch('refreshPageComps');
            Livewire.dispatch('reloadCompListData');
        }
        return true;
    }
    if (strIncludes(message, 'Alpine Expression Error')) {
        if (Livewire !== undefined) {
            Livewire.dispatch('refreshPageComps');
            Livewire.dispatch('reloadCompListData');
        }
        return true;
    }
    if (strIncludes(message, 'Livewire')) {
        if (Livewire !== undefined) {
            Livewire.dispatch('refreshPageComps');
            Livewire.dispatch('reloadCompListData');
        }
        return true;
    }
    if (strIncludes(message, 'Alpine')) {
        if (Livewire !== undefined) {
            Livewire.dispatch('refreshPageComps');
            Livewire.dispatch('reloadCompListData');
        }
        return true;
    }
    if (strIncludes(message, "null is not an object (evaluating 'Object.prototype.hasOwnProperty.call")) {
        return true;
    }
    if (strIncludes(message, "null is not an object (evaluating 'document.elementFromPoint")) {
        return true;
    }
    if (strIncludes(message, "null is not an object (evaluating 'e.contentWindow.postMessage")) {
        return true;
    }
    if (strIncludes(message, "Unable to decode audio data")) {
        return true;
    }
    if (strIncludes(message, "Jsloader error (code #1): Timeout reached for loading script https://apis.google.com/js/client.js")) {
        return true;
    }
    if (strIncludes(message, "Jsloader error (code #1):")) {
        return true;
    }
    if (strIncludes(message, "apis.google.com/js/client.js")) {
        return true;
    }
    if (strIncludes(message, "TypeError: Cannot convert undefined or null to object")) {
        return true;
    }
    if (strIncludes(message, "Cannot read properties of undefined")) {
        return true;
    }
    if (strIncludes(message, "Cannot read")) {
        return true;
    }
    if (strIncludes(message, "TypeError")) {
        return true;
    }
    if (strIncludes(message, "Uncaught")) {
        return true;
    }
    if (strIncludes(message, "gmp-")) {
        return true;
    }
    if (strIncludes(message, "already defined")) {
        return true;
    }
    if (strIncludes(message, "google.maps")) {
        return true;
    }
    if (strIncludes(message, "deprecated")) {
        return true;
    }
    if (strIncludes(message, "HTMLDialogElement")) {
        return true;
    }
    if (strIncludes(message, "Failed to read")) {
        return true;
    }
    if (strIncludes(message, "Error finding scrollable element")) {
        return true;
    }
    if (strIncludes(message, "Error CL001: Multiple Clarity tags detected.")) {
        return true;
    }
    if (strIncludes(message, "Electron")) {
        return true;
    }
    if (strIncludes(message, "Content-Security-Policy")) {
        return true;
    }
    if (strIncludes(message, "Could not read from file")) {
        return true;
    }
    if (strIncludes(message, "Failed to get initial setup")) {
        return true;
    }
    if (strIncludes(message, "contentscript")) {
        return true;
    }
    if (strIncludes(message, "Cannot read properties of null")) {
        return true;
    }
    if (strIncludes(message, "Cannot assign to read only property")) {
        return true;
    }
    if (strIncludes(message, "Maximum call stack size exceeded")) {
        return true;
    }
    if (strIncludes(message, "Failed to fetch dynamically imported module: https://www.googletagmanager.com")) {
        return true;
    }
    if (strIncludes(message, "googletagmanager.com")) {
        return true;
    }
    if (strIncludes(message, "google.maps.Marker")) {
        return true;
    }
    if (strIncludes(message, "analytics_debug.js")) {
        return true;
    }
    if (strIncludes(message, "Data from this session is not being collected by Microsoft Clarity due to your configured project settings")) {
        return true;
    }
    if (strIncludes(message, "A plugin named")) {
        return true;
    }
    if (strIncludes(message, "tiptap")) {
        return true;
    }
    if (strIncludes(message, "videojs")) {
        return true;
    }
    if (strIncludes(message, "[USO]")) {
        return true;
    }
    if (strIncludes(message, "Invalid event parameter")) {
        return true;
    }
    if (strIncludes(source, "gtag")) {
        return true;
    }
    if (strIncludes(source, "realworklabs")) {
        return true;
    }
    if (strIncludes(source, "Hotjar")) {
        return true;
    }
    if (strIncludes(source, "Ahrefs")) {
        return true;
    }
    if (strIncludes(source, "Electron")) {
        return true;
    }
    if (strIncludes(source, "tiptap")) {
        return true;
    }
    if (strIncludes(source, "videojs")) {
        return true;
    }
    if (strIncludes(source, "Electron Security Warning")) {
        return true;
    }
    if (strIncludes(source, "unsafe-eval")) {
        return true;
    }
    if (strIncludes(source, "Insecure Content-Security-Policy")) {
        return true;
    }
    if (strIncludes(source, "google.maps")) {
        return true;
    }
    if (strIncludes(source, "youtube.com")) {
        return true;
    }
    if (strIncludes(source, "analytics_debug.js")) {
        return true;
    }
    if (strIncludes(source, "google-analytics.com")) {
        return true;
    }
    if (strIncludes(source, "chrome-extension") || strIncludes(source, "moz-extension") || strIncludes(source, "tracking_script.js") || strIncludes(source, "injected.js") || strIncludes(source, "contentscript.js") || strIncludes(message, "Extension context invalidated.") || strIncludes(message, "contentscript")) {
        return true;
    }
    if (!strIncludes(source, window.location.hostname)) {
        return true;
    }
    const userAgent = navigator?.userAgent?.toLowerCase();
    if (userAgent && (
        /mobi|ipad|iphone|android|touch|mini/.test(userAgent) || // mobile devices
        /facebookexternalhit|facebookcatalog|fbav|semrush|googlebot|hotjar|ahrefs|yandax|openai|chatgpt|claude|instagram|whatsapp|twitterbot|linkedinbot|pinterest|crawler|spider|bot/.test(userAgent) // crawlers
    )) {
        return true;
    }
}
const originalWarn = console.warn;
console.warn = function(message, ...optionalParams) {
    if (window.location.hostname === 'tba-qikcms.test') {
        console.log('Warning:', message, optionalParams);
    }
    window._warnings = window._warnings || [];
    window._warnings.push({ message, ...optionalParams });
    if (window.flare) {
        window.flare.reportMessage(message, ...optionalParams);
    }
    // originalWarn(message, ...optionalParams);
}
if (window.location.hostname !== 'tba-qikcms.test'){
    if (window.flare && flare) {
        flare.beforeSubmit = function(report) {
            let passedChecks = true;
            if (strIncludes(report?.message, 'Alpine Expression Error')) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, 'Alpine')) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, 'Livewire')) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, 'contentWindow')) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, 'Snapshot missing')) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, 'Could not find Livewire component in DOM tree')) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, 'Component not found')) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "null is not an object (evaluating 'Object.prototype.hasOwnProperty.call')")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "null is not an object (evaluating 'document.elementFromPoint")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "null is not an object (evaluating 'e.contentWindow.postMessage")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "Unable to decode audio data")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "Jsloader error (code #1): Timeout reached for loading script https://apis.google.com/js/client.js")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "Jsloader error (code #1):")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "apis.google.com/js/client.js")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "TypeError: Cannot convert undefined or null to object")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "Cannot read properties of undefined")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "Cannot read")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "TypeError")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "Uncaught")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "gmp-")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "already defined")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "google.maps")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "deprecated")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "HTMLDialogElement")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "Failed to read")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "Error finding scrollable element")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "Error CL001: Multiple Clarity tags detected.")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "Electron")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "Content-Security-Policy")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "Could not read from file")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "Failed to get initial setup")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "Cannot read properties of null")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "Cannot assign to read only property")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "Maximum call stack size exceeded")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "contentscript")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "Failed to fetch dynamically imported module: https://www.googletagmanager.com")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "googletagmanager.com")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "google.maps.Marker")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "analytics_debug.js")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "Data from this session is not being collected by Microsoft Clarity due to your configured project settings")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "tiptap")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "videojs")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "A plugin named")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "[USO]")) {
                passedChecks = false;
            }
            if (strIncludes(report?.message, "Invalid event parameter")) {
                passedChecks = false;
            }
            if (strIncludes(report?.source, "gtag")) {
                passedChecks = false;
            }
            if (strIncludes(report?.source, "realworklabs")) {
                passedChecks = false;
            }
            if (strIncludes(report?.source, "Hotjar")) {
                passedChecks = false;
            }
            if (strIncludes(report?.source, "Ahrefs")) {
                passedChecks = false;
            }
            if (strIncludes(report?.source, "Electron")) {
                passedChecks = false;
            }
            if (strIncludes(report?.source, "tiptap")) {
                passedChecks = false;
            }
            if (strIncludes(report?.source, "videojs")) {
                passedChecks = false;
            }
            if (strIncludes(report?.source, "Electron Security Warning")) {
                passedChecks = false;
            }
            if (strIncludes(report?.source, "unsafe-eval")) {
                passedChecks = false;
            }
            if (strIncludes(report?.source, "Insecure Content-Security-Policy")) {
                passedChecks = false;
            }
            if (strIncludes(report?.source, "google.maps")) {
                passedChecks = false;
            }
            if (strIncludes(report?.stacktrace[0]?.file, "realworklabs.com")) {
                passedChecks = false;
            }
            if (strIncludes(report?.stacktrace[0]?.file, "youtube.com")) {
                passedChecks = false;
            }
            if (strIncludes(report?.stacktrace[0]?.file, "injected.js")) {
                passedChecks = false;
            }
            if (strIncludes(report?.stacktrace[0]?.file, "analytics_debug.js")) {
                passedChecks = false;
            }
            if (strIncludes(report?.stacktrace[0]?.file, "google-analytics.com")) {
                passedChecks = false;
            }
            if (strIncludes(report?.stacktrace[0]?.file, "chrome-extension") || strIncludes(report?.stacktrace[0]?.file, "moz-extension") || strIncludes(report?.stacktrace[0]?.file, "tracking_script.js") || strIncludes(report?.stacktrace[0]?.file, "injected.js") || strIncludes(report?.stacktrace[0]?.file, "contentscript.js")) {
                passedChecks = false;
            }
            if (!strIncludes(report?.stacktrace[0]?.file, window.location.hostname)) {
                passedChecks = false;
            }
            let userAgent = navigator?.userAgent?.toLowerCase();
            if (!userAgent) {
                userAgent = report?.context?.userAgent?.toLowerCase();
            }
            if (
                /mobi|ipad|iphone|android|touch|mini/.test(userAgent) || // mobile devices
                /facebookexternalhit|facebookcatalog|fbav|semrush|googlebot|hotjar|ahrefs|yandax|openai|chatgpt|claude|instagram|whatsapp|twitterbot|linkedinbot|pinterest|crawler|spider|bot/.test(userAgent) // crawlers
            ) {
                passedChecks = false;
            }
            if (!passedChecks) {
                return false;
            }
            return report;
        }
    }
}

// window.loadPDFJsLib = function () {
//     const libs = [
//         { global: "Processing", url: "https://cdnjs.cloudflare.com/ajax/libs/processing.js/1.4.1/processing-api.min.js" },
//         { global: "pdfjsLib", url: "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js" }
//     ];
//     libs.forEach(lib => {
//         if (!window[lib.global]) {
//             const s = document.createElement("script");
//             s.src = lib.url;
//             s.defer = true;
//             s.fetchPriority = "low";
//             document.head.appendChild(s);
//         }
//     });
//     var pdfjsLib = window['pdfjs-dist/build/pdf'];
//     console.log('PDF.js library loaded', Object.assign({}, pdfjsLib));
//     pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
//     return pdfjsLib;
// }

window.loadPDFJsLib = function () {
    const libs = [
        { global: "Processing", url: "https://cdnjs.cloudflare.com/ajax/libs/processing.js/1.4.1/processing-api.min.js" },
        { global: "pdfjsLib", url: "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js" }
    ];
    function loadScriptIfMissing(globalName, url) {
        return new Promise((resolve, reject) => {
            // Already loaded
            if (window[globalName]) {
                return resolve(window[globalName]);
            }

            // Already loading (by URL)?
            const existing = Array.from(document.scripts).find(s => s.src === url);
            if (existing) {
                existing.addEventListener("load", () => resolve(window[globalName]));
                existing.addEventListener("error", () => reject(new Error("Failed to load " + url)));
                return;
            }

            // Create script
            const s = document.createElement("script");
            s.src = url;
            s.defer = true;
            s.fetchPriority = "low";

            s.addEventListener("load", () => resolve(window[globalName]));
            s.addEventListener("error", () => reject(new Error("Failed to load " + url)));

            document.head.appendChild(s);
        });
    }

    // Load both libs, then configure PDF.js
    return Promise.all([
        loadScriptIfMissing(libs[0].global, libs[0].url), // Processing
        loadScriptIfMissing(libs[1].global, libs[1].url)  // pdfjsLib
    ]).then(([Processing, pdfjsLib]) => {
        if (!pdfjsLib || !pdfjsLib.GlobalWorkerOptions) {
            throw new Error("PDF.js did not load correctly.");
        }
        // Set worker src if not already set
        pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";
        return pdfjsLib;
    });
};

window.loadDoc = function (url) {
    window.loadPDFJsLib().then(pdfjsLib => {
        if (url) {                
            var pdfDoc = null,
                pageNum = 1,
                pageRendering = false,
                pageNumPending = null,
                scale = 1,
                canvas = document.getElementById('the-canvas'),
                ctx = canvas.getContext('2d');
            function renderPage(num) {
                pageRendering = true;
                document.getElementById('page-loader').classList.remove('hidden');
                pdfDoc.getPage(num).then(function(page) {
                    var viewport = page.getViewport({scale: scale});
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;
                    var renderContext = {
                        canvasContext: ctx,
                        viewport: viewport
                    };
                    var renderTask = page.render(renderContext);
                    renderTask.promise.then(function() {
                        pageRendering = false;
                        document.getElementById('page-loader').classList.add('hidden');
                        if (pageNumPending !== null) {
                            renderPage(pageNumPending);
                            pageNumPending = null;
                        }
                    });
                });
                document.getElementById('page_num').textContent = num;
            }
            function queueRenderPage(num) {
                if (pageRendering) {
                    pageNumPending = num;
                } else {
                    renderPage(num);
                }
            }
            function onPrevPage() {
                if (pdfDoc.numPages > 1) {
                    document.getElementById('next').classList.remove('opacity-25');
                }
                if (pageNum <= 1) {
                    return;
                }
                pageNum--;
                queueRenderPage(pageNum);
                if (pageNum <= 1) {
                    document.getElementById('prev').classList.add('opacity-25');
                }
            }
            document.getElementById('prev').addEventListener('click', onPrevPage);
            function onNextPage() {
                if (pageNum === (pdfDoc.numPages-1)) {
                    document.getElementById('next').classList.add('opacity-25');
                }
                if (pageNum >= pdfDoc.numPages) {
                    return;
                }
                pageNum++;
                queueRenderPage(pageNum);
                if (pageNum > 1) {
                    document.getElementById('prev').classList.remove('opacity-25');
                }
            }
            document.getElementById('next').addEventListener('click', onNextPage);
            pdfjsLib.getDocument(url).promise.then(function(pdfDoc_) {
                pdfDoc = pdfDoc_;
                document.getElementById('page_count').textContent = pdfDoc.numPages;
                if (pdfDoc.numPages > 1) {
                    document.getElementById('next').classList.remove('opacity-25');
                }
                renderPage(pageNum);
            });
        }
    }).catch(err => {
        console.error("PDF.js library error:", err);
    });
}

window.loadChatSounds = function () {
    const sounds = [
        { id: 'soundAlert', src: 'alert.mp3' },
        { id: 'soundBell', src: 'bell.mp3' },
        // { id: 'soundBellRing', src: 'bellring.mp3' },
        // { id: 'soundButton', src: 'button.mp3' },
        // { id: 'soundClick', src: 'click.mp3' },
        { id: 'soundDing', src: 'ding.mp3' },
        { id: 'soundNew', src: 'new.mp3' },
        { id: 'soundPing', src: 'ping.mp3' },
        { id: 'soundPop1', src: 'pop1.mp3' },
        // { id: 'soundPop2', src: 'pop2.mp3' },
        // { id: 'soundPop3', src: 'pop3.mp3' },
        { id: 'soundSwoosh', src: 'swoosh.mp3' },
        { id: 'soundWhoosh', src: 'whoosh.mp3' }
    ];
    sounds.forEach(sound => {
        if (!document.getElementById(sound.id)) {
            const audio = document.createElement('audio');
            audio.id = sound.id;
            audio.src = "https://cdn.qikcms.com/core/sounds/"+sound.src;
            audio.preload = 'auto';
            document.body.appendChild(audio);
        }
    });
}
window.playChatSound = function (id) {
    const el = document.getElementById(id);
    if (!el) return;
    el.currentTime = 0;
    el.volume = 0.4;
    el.play().catch(() => {});
}

window.addEventListener('pageshow', e => {
    if (e.persisted) window.location.reload();
});
